export const track = (eventType, opts) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger(`fulfillment.${eventType}`, opts);
  }
};
